import React from 'react';

interface IIconProps {
  className?: string;
}

const Icon = (props: IIconProps) => {
  const { className } = props;

  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h48v48H0z" />
        <g stroke="#4468FF" strokeWidth="3">
          <path d="M36.026 15.369A15.436 15.436 0 0 1 39 24.501C39 33.06 32.06 40 23.5 40 14.94 40 8 33.06 8 24.5 8 15.94 14.94 9 23.5 9c3.373 0 6.494 1.079 9.04 2.908" />
          <path d="M32 24.5a8.5 8.5 0 1 1-17.002-.002A8.5 8.5 0 0 1 32 24.5z" />
          <path d="M25 24.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" fill="#4468FF" />
          <path d="M39.122 12.459l-4.665 4.663-3-.455L31 13.665 35.663 9l.552 2.907zM31.416 17L24 24.415" />
        </g>
      </g>
    </svg>
  );
};

export default React.memo(Icon);
